import { createIcon } from '@chakra-ui/icons';

export const CookingIcon = createIcon({
  displayName: 'CookingIcon',
  viewBox: '0 0 29 29',
  d: 'M28.112 24.93a2.055 2.055 0 01-.04 2.847 2.009 2.009 0 01-2.817.039l-6.192-6.258-4.763 4.815L3.822 15.78A10.952 10.952 0 01.666 8.248 10.96 10.96 0 013.587.618l.235-.243 24.29 24.554z',
});
